// @flow
import type Scroller from "./index.js";

export default class Handler {
	scroller: Scroller;

	constructor(scroller: Scroller) {
		this.scroller = scroller;
	}

	mount() {}
	unmount() {}
	// eslint-disable-next-line no-unused-vars
	handleScroll(nextScroll: number, lastScroll: number) {}
}



// WEBPACK FOOTER //
// ./lib/scroller/handler.js